"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var columnizeListItems = function columnizeListItemsFunction(items) {
  var listMidpoint;

  if (items.length > 1) {
    switch (items.length % 2) {
      case 0:
        listMidpoint = items.length / 2;
        break;

      case 1:
        listMidpoint = (items.length + 1) / 2;
        break;

      default:
        break;
    }

    return {
      leftColumnItems: items.slice(0, listMidpoint),
      rightColumnItems: items.slice(listMidpoint)
    };
  }

  return {
    leftColumnItems: items
  };
};

var _default = columnizeListItems;
exports["default"] = _default;